import { useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';

import { Tooltip } from '../Tooltip';

type HoverableIconProps = {
  icon: React.ReactNode;
  tooltip: React.ReactNode;
};

export const HoverableIcon = ({ icon, tooltip }: HoverableIconProps) => {
  const { isDarkMode } = useSiteTheme();
  const ref = useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(ref);

  return (
    <Tooltip
      align="center"
      open={isHovering}
      triggerContent={<div ref={ref}>{icon}</div>}
      contentVariant={isDarkMode ? 'light' : 'darkGray'}
    >
      {tooltip}
    </Tooltip>
  );
};
